import { useEffect } from 'react'
// @ts-ignore
import lifecycle from 'page-lifecycle'

export default function UpdateChecker(): JSX.Element {
  useEffect(() => {
    const checkForUpdate = () => {
      navigator.serviceWorker?.ready.then((registration) => {
        console.log('[UpdateChecker] Checking for service worker update...')
        registration.update()
      })
    }

    checkForUpdate()

    const onStateChange = (event: any) => {
      try {
        const lastUpdateCheck = JSON.parse(window.localStorage.getItem('lastUpdateCheck')) ?? 0
        const shouldCheckUpdate = Date.now() - lastUpdateCheck > 60_000 // check once per minute

        if (event.newState === 'active' && shouldCheckUpdate) {
          window.localStorage.setItem('lastUpdateCheck', JSON.stringify(Date.now()))
          checkForUpdate()
        }
      } catch (e) {
        console.log(e)
        // An error here likely means localStorage is disabled.
        return
      }
    }

    lifecycle.addEventListener('statechange', onStateChange)

    return () => lifecycle.removeEventListener('statechange', onStateChange)
  }, [])

  return null
}
